import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    text: String,
  }

  copy() {
    navigator.clipboard.writeText(this.textValue)
    this.replaceButtonIcon()
  }

  replaceButtonIcon() {
    const button = this.element.querySelector('button')
    button.classList.toggle('has-copied')
    button.disabled = true

    setTimeout(() => {
      button.classList.toggle('has-copied')
      button.setAttribute('disabled', true)
    }, 2000)
  }
}
